export const CONTACT_DETAILS = {
  email: "pieandlattesstudio@gmail.com",
  phoneDisplay: "+44 7884 788700",
  phoneHref: "tel:+447884788700",
};

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/pieandlattespilates/",
  facebook: "https://www.facebook.com/PieandLattesPilatesStudio/",
};

export const VAGARO_BOOKING_URL = "https://www.vagaro.com/Users/BusinessWidget.aspx?enc=MMLjhIwJMcwFQhXLL7ifVKouySDq1UQ9xdIsIvlmMBQxmXwwFkpsq6sNLXqanH71aOc8MXbCx7hVMtS9MWdaX1cfMM1C2rkxD4nu+Xh+epkjD/RiX6AEJPEhw8XGdQeyWwVWJR9VF7UUMSuCNSoo9tUSFQFtNEgnmT+c2GVHfJ2K8g0hTWl4vsyG53Ju2VVGBMgYYJ85CLSowwjHhTSjfsKdDaYbVMehamtGkEonuyAcQ7MmL8irxGJa1bdRZmvKnMLkqsVm+fYNEdbhR+uxVoewNxYAjvY321mcBP8PdLhEaFmnYy7zInjdrthCvvtPJdlrOuvUXRlqABjHU5OaSrFgaX21E0r1Ju5K5fpCA2oQ6pixadGyyBX6+qHWyE77Cz+ME79V6MriN+m5eEAfQ/lRgrqpm/3RhTKxW4kdumTBPyue6xzREaqkhWCmwVEKKTRNJRAmGWmvz3bfLXIQ4/J9v0Cmj86o33HCBX/ZH9lzqp/Bz5X86y3ZhEBXb2kC";
